import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "60",
  height: "60",
  rx: "30",
  fill: "white",
  "fill-opacity": "0.12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0.5",
  y: "0.5",
  width: "59",
  height: "59",
  rx: "29.5",
  stroke: "white",
  "stroke-opacity": "0.32"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "30",
  cy: "30",
  r: "23.5",
  fill: "white",
  stroke: "#DCDEE3"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M31.3916 21.1084C31.7347 20.759 32.2552 20.6516 32.709 20.8369C33.1625 21.0223 33.46 21.4637 33.46 21.9541V38.0459C33.46 38.5363 33.1627 38.9777 32.709 39.1631C32.2551 39.3485 31.7348 39.2404 31.3916 38.8906L27.1533 34.5723L20.8047 34.5742C20.4845 34.5742 20.1773 34.4467 19.9512 34.2207C19.725 33.9945 19.5979 33.6878 19.5977 33.3682V26.6318C19.5979 25.9655 20.1383 25.4258 20.8047 25.4258H27.1543L31.3916 21.1084ZM37.0205 26.0107C37.5376 25.5914 38.2976 25.6694 38.7178 26.1865V26.1875C40.7429 28.6832 41.0238 32.0471 39.1133 34.9619C38.7479 35.5191 37.9997 35.6747 37.4424 35.3096C36.8849 34.9442 36.7295 34.1961 37.0947 33.6387C38.4192 31.6179 38.2191 29.4028 36.8438 27.708C36.4239 27.1904 36.5034 26.4306 37.0205 26.0107Z",
  fill: "black",
  stroke: "#DCDEE3",
  "stroke-width": "0.804599",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }